// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3lafeBRGU3yxyX-Y9Hvohf {\n  display: list-item;\n  background: none;\n  border: none;\n  padding: .6rem;\n  color: #bdbdbd;\n  cursor: pointer;\n  text-transform: uppercase;\n  text-decoration: none;\n  transition: .2s all;\n}\n._3lafeBRGU3yxyX-Y9Hvohf:hover {\n  color: #fff;\n}\n._3lafeBRGU3yxyX-Y9Hvohf:focus {\n  outline: none;\n  background: rgba(255,255,255,.08);\n}\n._2hGuI8okwPg_DgyduCIrYt {\n  color: #fff;\n}\n._1vLf80-wWSIKPhaSBJHYvO {\n  pointer-events: none;\n  opacity: 0.5;\n}\n", ""]);
// Exports
exports.locals = {
	"ComponentLink": "_3lafeBRGU3yxyX-Y9Hvohf",
	"ActiveComponentLink": "_2hGuI8okwPg_DgyduCIrYt",
	"DisabledComponentLink": "_1vLf80-wWSIKPhaSBJHYvO"
};
module.exports = exports;
